import * as app from './scripts/Core/App';
import Map from './scripts/Modules/Map';
import Hotjar from './scripts/Modules/Hotjar';
import UltimasNotas from './scripts/Modules/UltimasNotas';
import ComprarEntradas from './scripts/Modules/ComprarEntradas';

app.start().then(() => {
    const hotjar = new Hotjar();
    hotjar.tagRecording('teatro');

    const map = new Map('mapid');
    map.Draw();

    // Evento de boton COMPRAR ENTRADAS
    ComprarEntradas.initialize();

    // init ultimas notas de teatro
    //const ultimasNotas = new UltimasNotas({ max: 3 });
    //ultimasNotas.LoadUltimasDeTeatro();
});



// WEBPACK FOOTER //
// ./Statics/Teatro.js